<ng-container *ngIf="copilotFindings.size || analyzing">
   <div class="datex-tabcontrol datex-copilot-analysis">
      <div class="tab-container copilot-proxy">
         <ng-container *ngFor="let tabItem of tabs | keyvalue">
            <div class="tab datex-copilot-tab"
                 #tab
                 *ngIf="hasFindings(tabItem.key) || analyzing"
                 (click)="onActivateClicked(tabItem.key, tabItem.value)">
               <div class="datex-copilot-spinner"
                    #spinner
                    *ngIf="!hasFindings(tabItem.key) && analyzing"></div>

               <h3 [className]="titleClassName(tabItem.key, tabItem.value)">{{ tabItem.value.title }}</h3>
               <span *ngIf="hasFindings(tabItem.key) && hasUncompletedFindings(tabItem.key)"
                     [className]="badgeClassName(tabItem.key)">{{findingsBadgeCount(tabItem.key)}}</span>
            </div>
         </ng-container>
      </div>
      <ng-container *ngFor="let analysisType of copilotFindings | keyvalue">
         <ng-container *ngIf="tabs.get(analysisType.key).isActive && analysisType.value.length">
            <div *ngFor="let finding of analysisType.value"
                 [ngClass]="['datex-copilot-line']"
                 (click)="onSelectFinding(finding)"
                 (mouseover)="onMouseOver(finding)"
                 (mouseout)="onMouseOut(finding)">
               <i class="icon icon-ic_fluent_{{severityClassName(finding)}}"></i> 
               <span [ngClass]="[findingClassName(finding)]">
                  Line {{finding.lineNumber}}: {{finding.description}}
               </span>
               
            </div>
         </ng-container>
      </ng-container>
   </div>
</ng-container>